function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M7.939.529l-.859.862c-.211.211-.33.497-.33.795 0 .277.103.544.289.75L5.063 4.91l-.518-.518c-.44-.438-1.15-.438-1.59 0L1.721 5.625l2.063 2.063-2.925 2.92.532.533 2.921-2.925 2.063 2.063 1.234-1.234c.438-.44.438-1.15 0-1.59l-.518-.518 1.977-1.976c.205.186.472.288.75.289.298 0 .584-.119.795-.33l.862-.859L7.939.53zM7.08 7.984c.071.07.11.166.11.266s-.039.196-.11.266l-.705.705-3.596-3.596.705-.705c.07-.071.166-.11.266-.11s.196.039.266.11l.518.518 2.029 2.028.517.518zm-1.5-2.546l1.973-1.973.97.971-1.96 1.973-.983-.971zm4.5-1.047c-.07.071-.166.111-.266.111s-.196-.04-.266-.11l-1.94-1.94c-.069-.07-.108-.164-.108-.262 0-.1.039-.195.109-.266l.33-.33 2.471 2.471-.33.326z",
  transform: "translate(-790 -6041) translate(790 6041)"
}))));

var SvgPin = function SvgPin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pin.b86ecfce.svg";
export { ForwardRef as ReactComponent };